'use client';
import React, { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    question: 'Catch live sports with Sling Consonantal Digital',
    answer:
      'Sling Consonantal Digital offers the best live sports coverage including NFL, NBA, MLB, NHL, NCAA Football, NCAA Basketball, Soccer, Tennis, and much more. With our Sports Extra add-on, you get even more sports channels like NFL RedZone, beIN Sports, and more. Choose from our SCD Orange plan for ESPN access or SCD Blue for FOX Sports coverage.',
  },
  {
    question: "Don't miss top news stories and breaking news",
    answer:
      'Stay informed with 24/7 live news coverage from CNN, FOX News, MSNBC, HLN, BBC America, and more. Our SCD Select plan is perfect for news lovers, offering the most comprehensive news channel lineup. Get breaking news alerts and live coverage of major events as they happen.',
  },
  {
    question: 'Top entertainment starting at just $19.99/mo',
    answer:
      'Enjoy endless entertainment with channels like TBS, TNT, FX, Bravo, E!, USA Network, Syfy, and more. Add premium channels like HBO Max, Showtime, Starz, and Cinemax to your plan for even more movies and original series. With Sling Consonantal Digital, you always have something great to watch.',
  },
  {
    question: 'Enjoy endless entertainment on demand',
    answer:
      'Beyond live TV, Sling Consonantal Digital gives you access to thousands of on-demand movies and TV shows. Our Cloud DVR lets you record up to 50 hours of content so you never miss your favorite programs. Watch on your schedule, not the network\'s.',
  },
  {
    question: 'Add premium channels to your lineup',
    answer:
      'Customize your Sling Consonantal Digital experience with premium add-ons. Add HBO Max for Game of Thrones and House of the Dragon. Add Showtime for Yellowjackets and Billions. Add Starz for Power and Outlander. Mix and match to build your perfect TV package.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="py-16 px-4 sm:px-6">
      <div className="max-w-3xl mx-auto">
        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div key={idx} className="accordion-item">
              <button
                className="accordion-header w-full text-left"
                onClick={() => toggle(idx)}
              >
                <span>{item.question}</span>
                <svg
                  className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === idx ? 'rotate-180 text-[#00b9ff]' : 'text-[#979797]'
                  }`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {openIndex === idx && (
                <div className="accordion-content">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Help center */}
        <p className="text-center text-[#979797] text-sm mt-8">
          Still have questions? Visit our{' '}
          <a href="#" className="text-[#00b9ff] font-bold hover:underline">
            Help Center
          </a>
          .
        </p>

        {/* Final CTA */}
        <div className="text-center mt-8">
          <a href="#plans" className="btn-primary text-base px-10 py-4">
            Sign Up
          </a>
        </div>
      </div>
    </section>
  );
}
